import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, Fragment } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import Intro from "../../elements/blocks/intro";
import KnowledgeForm from "../../elements/knowledge/knowledge-form";
import KnowledgeDelete from "../../elements/knowledge/knowledge-delete";
import Nope from "../../elements/blocks/nope";
import { useApiTenant } from "../../../api/api-tenant";
import { useRoles } from "../../../services/roles";
export default function KnowledgeEdit() {
    const { t } = useTranslation();
    const { id } = useParams();
    const api = useApiTenant();
    const roles = useRoles();
    const [isLoading, setIsLoading] = useState(true);
    const [knowledge, setKnowledge] = useState(null);
    useEffect(() => {
        api.GET_knowledge(id)
            .then(response => {
            setKnowledge(response.data.knowledge);
            setIsLoading(false);
        })
            .catch(error => {
            if (!api.isCancel(error)) {
                console.error(error);
                setIsLoading(false);
            }
        });
        return () => api.cancel();
    }, []);
    return (_jsxs(Fragment, { children: [_jsx(Intro, { name: knowledge ? knowledge.title : t("knowledge.knowledge") + " #" + id, breadcrumbs: [
                    {
                        name: t("knowledge.knowledge"),
                        link: "/knowledge",
                    },
                    {
                        name: knowledge ? knowledge.title : t("knowledge.knowledge") + " #" + id,
                        link: "/knowledge/" + id,
                    },
                    {
                        name: t("knowledge.edit-knowledge"),
                        link: "/knowledge/" + id + "/edit",
                    },
                ], loading: isLoading }), isLoading ? (_jsx(Fragment, {})) : knowledge ? (_jsxs(Fragment, { children: [_jsx(KnowledgeForm, { status: "edit", knowledge: knowledge }), (roles.isAdmin || roles.isManager) && (_jsx(KnowledgeDelete, { knowledge: knowledge }))] })) : (_jsx(Nope, { title: t("errors.404"), caption: t("error.knowledge.not-found") }))] }));
}
